import { jwtDecode } from 'jwt-decode';
import LocalStore from 'utils/LocalStore';

/* encapsulates the business logic of login method. */
class Auth {
  LOGIN_MODE_BST = 'BST';
  LOGIN_MODE_HST = 'HST';

  setLoginMode(value) {
    LocalStore.setLoginMode(value);
  }
  removeLoginMode() {
    LocalStore.removeLoginMode();
  }
  getLoginMode() {
    return LocalStore.getLoginMode();
  }

  isJwtExpired(token) {
    const jwtObj = jwtDecode(token);

    return jwtObj.exp < Date.now() / 1000;
  }
}

const authInstance = new Auth();

export default authInstance;
